<template>
  <div class="floor-logic floor">
    <div class="floor__hd">
      <div v-if="isSF">邮寄地址</div>
      <div v-else>
        <span>工程师上门回收</span>
        <span class="warn-color">保持通话畅通，客服稍后联系</span>
      </div>
    </div>
    <div class="floor__bd clearfix">
      <div class="visit-tip hsb-address fl" v-if="isSF">
        <p>{{ Q_CONST.COMPANY_INFO.ADDR }}</p>
        <p>电话号码：{{ Q_CONST.COMPANY_INFO.SF_TEL }} {{ Q_CONST.COMPANY_INFO.POST_CODE }}</p>
      </div>
      <div class="visit-tip fl" v-else>
        <p class="location">预约地址：{{ orderInfo.address }}</p>
        <p class="time">预约时间：{{ orderInfo.time }}</p>
        <p>联系姓名：{{ orderInfo.userName }}</p>
        <p>联系方式：{{ orderInfo.tel }}</p>
      </div>
      <div class="qrcode-tip fr">
        <img src="//s1.huishoubao.com/static/pc/1001/img/wx-er-code.jpg">
        <p>关注回收宝实时跟踪订单状态</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderInfo: Object,
    isSM: Boolean,
    isSF: Boolean
  }
};
</script>

<style lang="postcss" scoped>
.floor-logic {
  padding-bottom: 20px;
}
.location {
  line-height: 36px;
  background: url(//www.huishoubao.com/static/pc/1001/img/logo-location.png) no-repeat left 5px;
}
.visit-tip {
  p {
    padding-left: 40px;
    line-height: 36px;
  }
}
.hsb-address p {
  padding-left: 0;
}
.qrcode-tip {
  text-align: center;
}
.warn-color {
  font-size: 14px;
  color: #ff5f43;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/orderResult/floor-logic.vue